const componentsCommon = require("cb-components-common").default;
const request = componentsCommon.request;

export function getFundRank(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/funds/rank",
        method: "get",
        params: _params
    });
}

export function getCompanyEvaluate(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/funds/select",
        method: "get",
        params: _params
    });
}

export function rankDownload(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/funds/rank-download",
        method: "get",
        params: _params
    });
}

export function getExport(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/funds/select/export",
        method: "post",
        params: _params
    });
}

export function getCompanyReportData(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/funds/select/company-report-data",
        method: "post",
        data: _params
    });
}


